<mat-card appearance="outlined" class="custom-measure-component se-block" *ngIf="groups?.length > 0">
    <div class="horizontal-tables-container">
        <table *ngIf="group0" class="measure-table">
            <tr>
                <th scope="col">
                    <mat-icon>print</mat-icon>
                </th>
                <th scope="col">{{ group0.categoryName }}</th>
                <th scope="col">{{ group0.measures && group0.measures.length > 0 ? group0.measures[0].udM : "" }}</th>
            </tr>
            <tr *ngFor="let measure of group0.measures; index as i">
                <td [class.se-read-only]="readOnly">
                    <mat-checkbox
                        type="checkbox"
                        [(ngModel)]="measure.isPrintable"
                        (change)="onPrintableChange(group0.measures[i])"
                    ></mat-checkbox>
                </td>
                <td class="cell-name" [matTooltip]="measure.formulaDescription" matTooltipClass="mat-tooltip-bigger">
                    {{ measure.name }}
                </td>
                <td class="value-udm" *ngIf="measure.isCalculated">
                    <editable-cell
                        [ngModel]="group0.measures[i]"
                        path="value"
                        [isReadOnly]="readOnly || measure.isCalculated"
                    >
                    </editable-cell>
                </td>
                <td class="value-udm" *ngIf="!measure.isCalculated">
                    <editable-cell
                        [(ngModel)]="group0.measures[i]"
                        (valueChange)="onValueChange($event)"
                        path="value"
                        [isReadOnly]="readOnly || measure.isCalculated"
                    ></editable-cell>
                </td>
            </tr>
        </table>

        <div class="vertical-tables-container">
            <table *ngIf="group1" class="measure-table">
                <tr>
                    <th scope="col">
                        <mat-icon>print</mat-icon>
                    </th>
                    <th scope="col">{{ group1.categoryName }}</th>
                    <th scope="col">
                        {{ group1.measures && group1.measures.length > 0 ? group1.measures[0].udM : "" }}
                    </th>
                </tr>
                <tr *ngFor="let measure of group1.measures; index as i">
                    <td [class.se-read-only]="readOnly">
                        <mat-checkbox
                            type="checkbox"
                            [(ngModel)]="measure.isPrintable"
                            (change)="onPrintableChange(group1.measures[i])"
                        ></mat-checkbox>
                    </td>
                    <td
                        class="cell-name"
                        [matTooltip]="measure.formulaDescription"
                        matTooltipClass="mat-tooltip-bigger"
                    >
                        {{ measure.name }}
                    </td>
                    <td class="value-udm" *ngIf="measure.isCalculated">
                        <editable-cell
                            [ngModel]="group1.measures[i]"
                            path="value"
                            [isReadOnly]="readOnly || measure.isCalculated"
                        >
                        </editable-cell>
                    </td>
                    <td class="value-udm" *ngIf="!measure.isCalculated">
                        <editable-cell
                            [(ngModel)]="group1.measures[i]"
                            (valueChange)="onValueChange($event)"
                            path="value"
                            [isReadOnly]="readOnly || measure.isCalculated"
                        ></editable-cell>
                    </td>
                </tr>
            </table>
            <table *ngIf="group2" class="measure-table">
                <tr>
                    <th scope="col">
                        <mat-icon>print</mat-icon>
                    </th>
                    <th scope="col">{{ group2.categoryName }}</th>
                    <th scope="col">
                        {{ group2.measures && group2.measures.length > 0 ? group2.measures[0].udM : "" }}
                    </th>
                </tr>
                <tr *ngFor="let measure of group2.measures; index as i">
                    <td [class.se-read-only]="readOnly">
                        <mat-checkbox type="checkbox" [(ngModel)]="measure.isPrintable"></mat-checkbox>
                    </td>
                    <td
                        class="cell-name"
                        [matTooltip]="measure.formulaDescription"
                        matTooltipClass="mat-tooltip-bigger"
                    >
                        {{ measure.name }}
                    </td>
                    <td class="value-udm" *ngIf="measure.isCalculated">
                        <editable-cell
                            [ngModel]="group2.measures[i]"
                            path="value"
                            [isReadOnly]="readOnly || measure.isCalculated"
                        >
                        </editable-cell>
                    </td>
                    <td class="value-udm" *ngIf="!measure.isCalculated">
                        <editable-cell
                            [(ngModel)]="group2.measures[i]"
                            (valueChange)="onValueChange($event)"
                            path="value"
                            [isReadOnly]="readOnly || measure.isCalculated"
                        ></editable-cell>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</mat-card>
